import {gsap,Power1,Power2, Back, Linear} from 'gsap'
import ScrollToPlugin from '../assets/gsap/esm/ScrollToPlugin.js';
import {splitText} from './split-text.js'

gsap.registerPlugin(ScrollToPlugin);

/* global Power1 */


/************************************** */
/*************  VARS  ***************** */
/************************************** */
var easingGlobal = Power2.easeInOut;
var durationGlobal = 0.5;
var fadeOutDuration = durationGlobal * 0.66;



/************************************** */
/************  functions  ************* */
/************************************** */

function resetElement( $element ){
  gsap.set( $element, {
    clearProps: 'all'
  });
}


function setFooterOpacity(){
  var $footer = document.querySelector('footer');
  gsap.set($footer, {
    opacity: 0
  });
}


function setFooterSlideUp(){
  var $footer = document.querySelector('footer'); 
  var $footerInner = $footer.querySelector('.footer-inner');
  var footerHeight = $footerInner.offsetHeight;

  gsap.set($footerInner, {
    y: footerHeight + 10,
  })
  gsap.set($footer , {
    opacity: 1,
  })
}


function footerSlideUp( duration = 0 ){
  var $footer = document.querySelector('footer'); 
  var $footerInner = $footer.querySelector('.footer-inner');
  
  gsap.to($footerInner, {
    y: 0,
    opacity: 1,
    duration: duration
  })

  // get height incl. padding
  var footerHeight = $footerInner.offsetHeight;

  // hide footer plus 10px extra savety  
  gsap.set($footerInner, {
    y: footerHeight + 10,
  })

  gsap.set($footer , {
    opacity: 1,
  })
}


function footerSlideDown(){
  var $leavingContainer = document.querySelector('.leaving-container');

  var $footer = document.querySelector('footer');
  var transitionHeight = $footer.querySelector('.footer-inner').offsetHeight;

  // clone footer to prevent flicker and footer position jumps
  var $cloneFooter = $footer.cloneNode(true);

    $cloneFooter.classList.add('clone');
    document.getElementById("app").appendChild($cloneFooter);
    $footer.classList.add('opacity-null-instant');


  // get leaving container offset
  var top = $leavingContainer.offsetHeight + $leavingContainer.parentNode.offsetTop;

  // set clone footer where real footer was virtually
  gsap.set( $cloneFooter, {
    position: 'absolute',
    left: 0,
    right: 0,
    width: '100%',
    top: top, 
    margin: 0,
  });

  // fade out clone footer
  gsap.to( $cloneFooter, {
    ease: Power2.easeIn,
    duration: durationGlobal / 2,
    y: transitionHeight,
    onComplete: function(){
      $cloneFooter.remove();
    }
  });
}


function resetFooter( delay ){
  var $footer = document.querySelector('footer');
  gsap.set($footer, {
    delay: delay,
    clearProps: 'all'
  });
  // restore footer on page bottom 
  $footer.classList.remove('opacity-null-instant');
}


// prepare fade-out-container
function initFadeoutLeave( $fadeoutContainer, done, delay = 0){
  $fadeoutContainer.classList.add('leaving-container');
  $fadeoutContainer.classList.add('absolute');

  gsap.to($fadeoutContainer, {
    opacity: 0,
    duration: fadeOutDuration * 0.9,
    delay: delay,

    onComplete: function(){
      done();
    }
  });
}



function resetClone(){
    var $clone = document.querySelector('.clone-item');
    if( $clone ){ $clone.remove(); }

    var $hiddenItem = document.querySelector('.stream-item.hide');
    if( $hiddenItem ){ $hiddenItem.classList.remove('hide'); }
}



function createClone( $original, hideOriginal = true ){
  resetClone(); // first remove all old clone stuff if existing
  
  var $content = document.querySelector('#content');
  var $cloneItem = $original.cloneNode(true);

  if( hideOriginal === true ){
    $original.classList.add('hide');
  }

  // get args for clone start point
  var viewportOffset = $original.getBoundingClientRect();
  var itemArgsStart = {
      width: $original.offsetWidth,
      height: $original.offsetHeight,
      top: viewportOffset.top,
      left: viewportOffset.left,
  }


  // set identifier classes to element
  $cloneItem.classList.add('clone-item');


  // set start poistion clone
  $cloneItem.style.width = itemArgsStart.width + 'px';
  $cloneItem.style.height = itemArgsStart.height + 'px';
  $cloneItem.style.top = itemArgsStart.top + 'px';
  $cloneItem.style.left = itemArgsStart.left + 'px';


  // insert clone in dom
  $content.insertBefore( $cloneItem, $content.firstChild );
  return $cloneItem;
}


// get item offsets 
function createArgs( $item, duration, easing ){
  var viewportOffset = $item.getBoundingClientRect(); 
  var args = {
    width: $item.offsetWidth,
    height: $item.offsetHeight,
    top: viewportOffset.top,
    left: viewportOffset.left,
    duration: duration,
    ease: easing
  }
  return args;
}


// fade in enter container 
function reapearEnd( $enterContainer, delay){
  var $targetItem = document.querySelector('.target-display-none');
  var $clone = document.querySelector('.clone-item');

  // appear target under clone
  if( $targetItem ){
    $targetItem.classList.remove('target-display-none');
  }

  // clean up dom
  $clone.remove();
  $enterContainer.classList.remove( 'absolute' );
  resetFooter( delay );
}


function headerFadeOut(){
  var $header = document.querySelector('#header');
  gsap.to( $header, {
    opacity: 0,
    duration: durationGlobal / 2
  });
}

function headerFadeIn(){
  var $header = document.querySelector('#header');
  gsap.to( $header, {
    opacity: 1,
    duration: durationGlobal / 2
  });
}

function slideInBackButton( $backButton ){

  if( typeof( $backButton ) !== 'undefined' && $backButton !== null ){
    gsap.set( $backButton, {
      x: '-100%',
      opacity: 1
    });

    gsap.to( $backButton, {
      x: '0',
      duration: durationGlobal * 2,
      delay: durationGlobal * 0,
      ease: Back.easeInOut.config( 1 ), // https://greensock.com/docs/v3/Eases

      onComplete: function(){
        resetElement( $backButton );
        setTimeout( function(){
          // re-add hover ability 
          $backButton.classList.add('hover');
        }, 500);
      }
    });
  }
}






/************************************************* */
/*************    HOME TO DETAILS    ************* */
/************************************************* */


function homeToDetailsEnter($projectContainer, done, to){  
  footerSlideDown();
  $projectContainer.classList.add('absolute');

  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
  if( scrollTop > 0 ){
    headerFadeOut();
  }

  // hide fade-in-content
  gsap.set($projectContainer, {
    duration: durationGlobal / 2,
    opacity: 0,
  });


  var $clickItem = document.querySelector('.stream-item[data-id="' + to.params.projectID + '"]');
  if( !$clickItem ){ return; }

  // clone list image from index page
  var $clone = createClone( $clickItem );
  $clone.classList.add('hover-style')
  if( !$clone ){ return; }

  // clone target image and shrink it to list image size 
  var $teaserItem = document.querySelector('.portfolio-top-image');
  var $cloneFrame = $clone.querySelector('.frame');
  var $cloneTransitionContainer = $clone.querySelector('.transition-container');
  var $cloneImage = $clone.querySelector('img');

  var viewportOffset = $teaserItem.getBoundingClientRect(); 
  var newWidth = $teaserItem.offsetWidth;

  var cloneArgs = {
    width: newWidth,
    height: newWidth / $teaserItem.getAttribute('ratio'),
    top: viewportOffset.top + scrollTop,
    left: viewportOffset.left,
    duration: durationGlobal,
    ease: easingGlobal,
  }


  $cloneImage.setAttribute('style',''); // reset before re-set
  // set size and position of clone image 
  gsap.set( $cloneImage, {
      scale: $cloneImage.getAttribute('data-scale'),
      x: $cloneImage.getAttribute('data-left') + '%',
      y: $cloneImage.getAttribute('data-top') + '%',
  });



  if( scrollTop >= 250 ){
    scrollTop = 250
  }
  
  var tl = gsap.timeline({ delay: fadeOutDuration });
  // size up clone image & frame to project details image
  tl
  .set(window, { 
    scrollTo: scrollTop,
  })
  .add( 'start' )
  .add(
    gsap.to( $cloneTransitionContainer, {
      scale: 1,
      height: '100%',
      width: '100%',
      duration: durationGlobal,
      ease: easingGlobal
    }), 'start'
  )
  .add(
    gsap.to( $clone, cloneArgs ), 'start'
  )
  .add(
    gsap.to( $cloneImage, {
      duration: durationGlobal,
      ease: easingGlobal,
      opacity: 1,
      scale: 1,
      translateX: '-50%',
      translateY: 0,
      top: 0,
      onStart: function(){
        slideInBackButton( $projectContainer.querySelector('#back-button') );
      }, 
    }), 'start'
  )
  .add(
    gsap.to( [$cloneFrame], {
      duration: durationGlobal,
      ease: Linear.easeNone,
      opacity: 0
    }), 'start'
  )
  .add(
    gsap.to( window, { 
      onStart: headerFadeIn,
      delay: durationGlobal / 2, 
      duration: durationGlobal / 2, 
      ease: easingGlobal, 
      scrollTo: 0
    }), 'start'
  )
  .set($projectContainer, {
    opacity: 1,
    onComplete: function(){
      splitText($projectContainer, 0.5);
      reapearEnd( $projectContainer );
      done();
    }
  });
}








/********************************************** */
/**********    DETAILS TO HOME    ************* */
/********************************************** */

function detailsToHomeEnter($streamContainer, done, delay){
  
  // hide footer
  setFooterOpacity();

  // hide index grid
  gsap.set($streamContainer,{
    opacity: 0,
  });


  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var $content = $streamContainer.parentNode;

  var $leavingContainer = document.querySelector('.leaving-container');
  var id = $leavingContainer.getAttribute('project-id');
  

  var $teaser = $leavingContainer.querySelector('#teaser-image');
  var $targetItem = $streamContainer.querySelector('.stream-item[data-id="'+id+'"]');
  var targetArgs = createArgs( $targetItem );
      $targetItem.classList.add('target-display-none');

  var $targetImage = $targetItem.querySelector('img');


  // set container
  var $clone = createClone( $teaser );
  var cloneArgs = createArgs( $targetItem, durationGlobal, easingGlobal );

  var innerHeight = $streamContainer.querySelector('#stream').offsetHeight;
  var targetOffset = $targetItem.offsetTop;
  var targetHeight = targetArgs.height;
  var containerHeight = $streamContainer.offsetHeight;

  var scrollAdjust = 0;

  // if target is below fold
  if( (targetArgs.top + targetArgs.height) >= window.innerHeight ){
    
    scrollAdjust = targetArgs.top - ((window.innerHeight - targetArgs.height) / 2);
    cloneArgs.top = (window.innerHeight - targetArgs.height) / 2;
    
    var contentHeight = $content.offsetHeight;
    var difference = contentHeight - containerHeight;
    var remainingBottom = innerHeight - targetOffset - targetHeight + difference;
   
    // if target is in last row || to low for vertical center
    if( remainingBottom <= cloneArgs.top ){
      // cloneArgs.top = window.innerHeight - targetArgs.height - remainingBottom;
      cloneArgs.top = window.innerHeight - targetArgs.height - remainingBottom;
    }
  }

  cloneArgs.top = cloneArgs.top + scrollTop;


  var headerOutDuration = durationGlobal * 0.5;
  var headerOutScrollTo = 0;
  
  if( scrollAdjust > 0){
    headerOutDuration = durationGlobal * 0.75;
    headerOutScrollTo = 250;
    $teaser.classList.add('opacity-null-instant');
  }





  // set img arg
  var $cloneImg = $clone.querySelector('img');
  var imgArgs = {
    x: ( parseInt($targetImage.getAttribute('data-left'), 10)) + '%',
    y: $targetImage.getAttribute('data-top') + '%',
    scale: $targetImage.getAttribute('data-scale'),
    duration: durationGlobal,
    ease: easingGlobal
  }

  // set img
  gsap.set( $cloneImg, {
    scale: 1,
    x: '-50%',
    y: 0,
  });


// set Span
var $span = $targetItem.querySelector('span');
gsap.set($span, {
  opacity: 0
});


  // set frame
  var $frame = document.createElement('div');
  $frame.classList.add('frame');
  gsap.set($frame, {
    opacity: 0
  });
  $clone.appendChild($frame);     


  /*   TIMELINE    */
  var tl = gsap.timeline({ 
    delay: delay
  });


  tl
  .add( 'before' )
  .to( window, {
    scrollTo: headerOutScrollTo,
    duration: headerOutDuration,
    ease: Power1.easeIn
  })

  .add( 'start' )
  .to( $cloneImg, 
    imgArgs
  )

  .add(
    gsap.to( $clone, 
      cloneArgs
    ), 'start'
  )

  .add(
    gsap.to( $frame, {
      opacity: 1, 
      duration: durationGlobal
    }), 'start'
  )

  .add(
    gsap.set(window, {
      onStart: headerFadeIn,
      scrollTo: scrollAdjust, 
    }), 'start'
  )

  .add(
    gsap.to($streamContainer, {
      opacity: 1,
      duration: durationGlobal / 2,
      delay: durationGlobal / 2,
      onComplete: function(){
        
        gsap.to($span, {
          opacity: 1, 
          duration: durationGlobal * 0.33
        });


        reapearEnd( $streamContainer, durationGlobal / 2 );
        footerSlideUp( durationGlobal / 2 );
        done();
      }
    }), 'start'
  )
}





/********************************************** */
/*********    DETAILS TO DETAILS    *********** */
/********************************************** */

function detailsToDetailsEnter($projectContainer, done){
  
  $projectContainer.classList.add('absolute');

  var $leavingContainer = document.querySelector('.leaving-container');
  var $nextTeaser = $leavingContainer.querySelector('#next');
  var $clone = createClone( $nextTeaser );


  footerSlideDown();


  gsap.set($projectContainer,{
    opacity: 0,
    top: 0,
  });


  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var $target = $projectContainer.querySelector('#teaser-image');
  
  var tl = gsap.timeline({ delay: durationGlobal * 0 });
  
  var $span = $clone.querySelector('span');
  var $img = $target.querySelector('img');
  var ratio = $img.getAttribute('ratio');

  var cloneArgs = createArgs( $target, durationGlobal, easingGlobal );
  cloneArgs.height = cloneArgs.width / ratio;
  cloneArgs.top = cloneArgs.top + scrollTop;



  tl
  .add( 'zero' )
  .to( $span, {opacity: 0, 
    duration: fadeOutDuration,
  })
  .add( 'start' )
  .set( window, {scrollTo: 250})
  .add(
    gsap.to( $clone, cloneArgs ), 'start'
  )
  .add(
    gsap.to( 
      $span, {opacity: 0, 
      duration: durationGlobal,
    }) , 'start'
  )
  .add(
    gsap.to( window, {
      scrollTo: 0,
      delay: durationGlobal / 2,
      duration: durationGlobal,
      ease: easingGlobal,
      onComplete: function(){
        reapearEnd( $projectContainer );
        splitText( $projectContainer, 0.1 );

      }
    }), 'start'
  )
  .set($projectContainer, {
    onStart: function(){
      slideInBackButton( $projectContainer.querySelector('#back-button') );
    },
    opacity: 1,
    onComplete: function(){
      done();
    }
  });
}


var easingSlide = Power2.easeInOut;


function addZChange( $container ){
  $container.parentNode.classList.add('z-index-change');
}


function removeZChange( $container ){
  $container.parentNode.classList.remove('z-index-change');
}


function initSlide( $container ){
  addZChange( $container );
  $container.classList.add('absolute');
}



function endSlide( $container ){
  removeZChange( $container );
  $container.classList.remove('absolute');
}


/********************************************** */
/**********      HOME TO ABOUT      *********** */
/********************************************** */

function centerToBottom( $container, done ){
  initSlide( $container );

  gsap.set( $container, {
    y: '0',
  });

  gsap.to( $container, {
    y: '100%',
    duration: durationGlobal,
    ease: easingSlide,
    onComplete: function(){
      endSlide( $container );
      done();
    }
  });
}


function topToCenter( $container, done ){
  initSlide( $container );
  var $footer = document.querySelector('footer .footer-inner');


  gsap.set( $container, {
    y: '-100vh',
    opacity: 0,
    duration: durationGlobal
  });


  gsap.set($footer, {
    y: '100%'
  });


  gsap.to( $container, {
    y: '0',
    opacity: 1,
    duration: durationGlobal,
    ease: easingSlide,
    onComplete: function(){
      endSlide( $container );
      done();


      gsap.to($footer, {
        y: '0%',
        duration: durationGlobal / 2,
        ease: Power2.easeOut,
        onComplete: function(){
          gsap.set($footer, {
            clearProps: 'all'
          });
        }
      });
    }
  });
}



function bottomToCenter( $container, done ){
  initSlide( $container );

  gsap.set( $container, {
    y: '100vh',
    opacity: 0
  });

  gsap.to( $container, {
    y: '0',
    opacity: 1,
    duration: durationGlobal,
    ease: easingSlide,
    onComplete: function(){
      endSlide( $container );
      done();
    }
  });
}


function centerToTop( $container, done ){
  var $footer = document.querySelector('footer .footer-inner');
  initSlide( $container );

  gsap.set( $container, {
    y: '0',
    opacity: 1,
    duration: durationGlobal
  });

  gsap.to($footer, {
    y: '100%',
    duration: durationGlobal / 2,
    ease: Power2.easeIn,
    onComplete: function(){
      
      gsap.to($footer, {
        y: 0,
        delay: durationGlobal,
        duration: durationGlobal / 2,
        ease: Power2.easeOut,
      });
    }
  });


  gsap.to( $container, {
    y: '-100vh',
    opacity: 0,
    duration: durationGlobal,
    ease: easingSlide,
    onComplete: function(){
      footerSlideUp();
      endSlide( $container );
      done();
    }
  });
}



/********************************************** */
/**********         PRIVACY         *********** */
/********************************************** */

function toPrivacyEnter($container, done){
  var $footer = document.querySelector('footer');
  var footerHeight = $footer.offsetHeight;
  var start = window.innerHeight - footerHeight;

  document.querySelector('#app').classList.add('privacy');
  
  gsap.set( $container, {
    y: start
  });

  gsap.to( $container, {
    y: '0',
    duration: durationGlobal,
    ease: easingGlobal,
    onComplete: function(){
      $container.classList.remove('absolute');
      done();
    }
  });
}


function toPrivacyLeave($container, done){
  gsap.to( window, {
    y: '0',
    duration: durationGlobal,
    ease: easingGlobal,
    onComplete: function(){
      $container.classList.remove('absolute');
      done();
    }
  });
}


function fromPrivacyEnter(){
  gsap.set( window, {
    scrollTo: 0
  });
}


function fromPrivacyLeave($container, done){
  gsap.set( $container, {
    y: '0'
  });

  gsap.to( $container, {
    y: '100vh',
    duration: durationGlobal,
    ease: easingGlobal,
    onComplete: function(){
      document.querySelector('#app').classList.remove('privacy');
      $container.classList.remove('absolute');
      done();
    }
  });
}


export { 
  homeToDetailsEnter,
  detailsToHomeEnter,
  initFadeoutLeave,
  detailsToDetailsEnter,
  topToCenter,
  centerToBottom,
  bottomToCenter,
  centerToTop,
  slideInBackButton,
  toPrivacyEnter,
  fromPrivacyEnter,
  toPrivacyLeave,
  fromPrivacyLeave,
  footerSlideDown,
  setFooterSlideUp,
  footerSlideUp
}
